import MatchCards from "../KbvMatchCards";

export default function TeamRow({
  name,
  yellow,
  red,
  score,
  halfScore,
  isWin,
  showScore,
  direction,
}) {
  return (
    <tr>
      <td className="px-2 py-1 flex justify-between gap-1">
        <div className="flex-1 min-w-0 flex items-center gap-1">
          <span className="text-sm truncate text-[var(--theme-text)]">{name}</span>
          <MatchCards yellow={yellow} red={red} direction={direction} />
        </div>
        {showScore && (
          <span
            className={`text-sm tabular-nums ml-2 ${isWin ? "font-bold" : ""}`}
          >
            {score}
            <span className="ml-1 text-sm text-[var(--text-half-score)] font-normal">
              ({halfScore})
            </span>
          </span>
        )}
      </td>
    </tr>
  );
}